let initialState = {
	ticketOffset: {
		widget_index: 0,
		id: "1",
	},
	ticketWidgetArray: null,
	ormDate: null,
	ormBrands: null,
};
const Orm = (state = initialState, action) => {
	switch (action.type) {
		case "SET_ORM_WIDGET_DATA":
			return {
				...state,
				ticketWidgetArray: action.payload,
			};
		case "SET_TICKET_OFFSET":
			return {
				...state,
				ticketOffset: action.payload,
			};
		case "SET_ORM_DATE":
			return {
				...state,
				ormDate: action.payload,
			};
		case "SET_ORM_BRANDS":
			return {
				...state,
				ormBrands: action.payload,
			};
		case "RESET_ORM_WIDGET":
			return {
				...state,
				ticketWidgetArray: action.payload,
			};
		default:
			return state;
	}
};

export default Orm;
